<template>
  <div class="footer-style">
    <div class="phone-footer" v-if="screenWidth <=1200">
      <!--footer-->
      <div class="page-footer">
        <!--<p v-for="item in fourthPageInfo.topTexts">{{item.text}}</p>-->
        <div class="list" v-for="item in fourthPage.topTexts" :key="item.title">
          <div class="left">
            {{item.title}}
          </div>
          <div class="right">
            <p v-for="txt in item.text" :key="txt"> {{txt}}</p>
          </div>
          <div class="clear"></div>
        </div>
        <div class="bottom-part">
          <div class="half" v-for="(item, index) in fourthPage.bottomTexts" :key="item.text">
            <a :href="item.link" v-if="item.link">{{item.text}}</a>
            <span v-else><img src="../../assets/images/webSite/company_logo.png" v-if="index == 1">{{item.text}}</span>
          </div>
          <div class="clear"></div>
        </div>
      </div>
      <!--<div class="right-action">-->
        <!--<div class="message">-->
          <!--<img src="../../assets/phone/page/contact.png" @click="handleClick">-->
        <!--</div>-->
        <!--<div class="top" v-show="isShowTopBtn">-->
          <!--<img src="../../assets/phone/page/top.png" @click="handleScrollTop">-->
        <!--</div>-->
      <!--</div>-->
        <right-action :isShowTopBtn="isShowTopBtn"></right-action>
      <!--联系方式弹框-->
      <van-dialog v-model="isShow" class="message-dialog" :showConfirmButton="false">
        <div class="contact">
          <div class="name">张经理</div>
          <div class="tel">
            <img src="../../assets/phone/page/tel.png">
            18914740518
          </div>
          <div class="email">
            <img src="../../assets/phone/page/email.png">
            zhangliangping@njinst.com
          </div>
        </div>
        <div class="close">
          <img src="../../assets/phone/page/close.png" @click="isShow = false">
        </div>
      </van-dialog>
    </div>
    <div class="pc-footer" v-else>
      <div class="sec-footer">
        <div class="top-part">
          <div class="top-item" v-for="(item, index) of fourthPage.topTexts" :key="'fourthTopText_'+index">
            {{item.title}}
            <span v-for="(txt,index) in item.text" :key="'text_'+index">
            <span v-if="index >0">, </span>
             {{txt}}
          </span>
          </div>
        </div>
        <div class="bottom-part">
          <div
            class="bottom-item"
            :class="{linker:item.link!=''}"
            v-for="(item, index) in fourthPage.bottomTexts"
            :key="'fourthBottomTexts_'+index"
            @click="beianLink(item.link)"
          ><img src="../../assets/images/webSite/company_logo.png" v-if="index == 1">{{item.text}}</div>
        </div>
        <!--<div class="other">-->
          <!--<div class="wechart pointer" @mouseenter="qrCode=true" @mouseleave="qrCode=false">-->
            <!--<img src="../../assets/images/page4/wechat.png" alt />-->
            <!--<div class="qr-code" v-show="qrCode" style="">-->
              <!--<img src="../../assets/images/page4/qr_code.png" alt />-->
            <!--</div>-->
          <!--</div>-->
          <!--<div class="to-top pointer" @click="toTop" title="返回顶部">-->
            <!--<img src="../../assets/images/page4/back_to_top.png" alt />-->
          <!--</div>-->
        <!--</div>-->
      </div>
        <right-action :isShowTopBtn="isShowTopBtn"></right-action>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';
import rightAction from './rightIcon';
export default {
    name: "footerCommon",
    props: ['isShowTopBtn'],
    data () {
        return {
            isShow: false, //弹框
            // isShowTopBtn: false,
            fourthPage: {
                topTexts: [
                    { title: '电话:',text: ["18068825213(张经理)"] },
                    { title: '地址:',text: ["南京市建邺区创智路1号北纬国际中心A座8楼"] },
                    { title: '邮箱:',text: ["sales@njinst.com"] }
                ],
                bottomTexts: [
                    { link:"", text: "Copright © 2020" },
                    { link:"", text: "南京英斯特网络科技有限公司" },
                    { link:"", text: "All Rights Reserved" },
                    { link:"http://beian.miit.gov.cn/",text: "苏ICP备11063938号" }
                ]
            },
            screenWidth: 0, //屏幕宽度
            qrCode: false
        };
    },
    components: {
        rightAction
    },
    methods: {
        // handleClick () {
        //     this.isShow = true;
        //     // window.open("http://bd.qq.com");
        // },
        // handleScrollTop () {
        //     if (this.$route.path==="/indexPage" || this.$route.path === "/") {
        //         $('#phone-page').animate({scrollTop: 0}, 500);
        //     } else {
        //         $('body,html').animate({scrollTop: 0}, 500);
        //     }
        // // this.$emit("scrollTop");
        // },
        beianLink(link){
            if (link!==""){
                window.open(link);
            }
        },
        toTop() {
            this.$emit("toTop");
            $('html').animate({scrollTop: 0}, 500);
        }
    },
    mounted() {
        let that = this;
        this.$nextTick(()=> {
            that.screenWidth = document.documentElement.clientWidth;
        });
        $(window).bind('resize',function () {
            that.screenWidth = document.documentElement.clientWidth;
        });
    }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/common/footerCommon.vue